
// Import CSS
import '../styles/main.scss';
import Sticky from "./components/sticky.js";
import Share from './components/share.js';
document.addEventListener('DOMContentLoaded', function () {
    const filter = document.getElementById('archives-singles-filter')
    const maillages = document.querySelectorAll('.maillage-wrapper')
    const swiperMaillage = {
        slidesPerView: 1,
        spaceBetween: 35,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },

        breakpoints: {
            640: {
                slidesPerView: 2,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            1024: {
                slidesPerView: 3,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    }

    console.log('[archive single] loaded')

    if (filter) {
        filter.addEventListener('change', function (e) {
               window.location.href = e.target.value
        })

    }

    maillages.forEach(function (maillage){
        const swiper = new Swiper(maillage, swiperMaillage)
    });


    new Sticky().start();
    new Share().start();
})